module.exports = __webpack_public_path__ + "static/media/liquors.049fb052.png";